import { cn } from "@cloai/uikit";

/**
 * @styles START_SCREEN_STYLES
 * Содержит стили для:
 * - title - стили заголовка
 * - grid - сетка карточек
 * - card - стили карточек
 * - image - стили изображений
 * - text - стили текста
 * - badge - стили бейджей
 */

export const START_SCREEN_STYLES = {
  // grid: cn(
  //   "grid w-full flex-grow-1 grid-cols-1 grid-rows-35 place-items-stretch gap-2 overflow-hidden",
  //   "md:grid-cols-2 md:grid-rows-23 md:gap-4",
  // ),
  grid: cn(
    "flex size-full flex-grow-1 flex-col place-items-stretch gap-2 overflow-hidden",
    "md:flex-row md:gap-4",
  ),
  collumn: cn("flex size-full shrink-2 flex-col gap-2", "md:gap-4"),
  card: {
    base: cn(
      "group/item @container relative cursor-pointer overflow-hidden select-none",
      "size-full rounded-xl",
      "flex items-end justify-center bg-card transition-[scale,background-color] duration-300",
      "hover:bg-[oklch(from_var(--color-card)_calc(l_+_0.1)_c_h)]",
      "active:scale-95 active:bg-[oklch(from_var(--color-card)_calc(l_+_0.05)_c_h)] active:duration-100",
    ),
    variant: {
      video: cn("shrink-5", "md:shrink-2"),
      banner: cn("flex h-13 shrink-0 items-center justify-between px-3"),
      prompt: cn("flex h-15 shrink-0 items-center justify-center", "md:h-20"),
      group: cn(
        "flex size-full items-center justify-center gap-2 rounded-2xl",
        "md:gap-4",
      ),
    },
    disabled: cn("pointer-events-none opacity-70"),
  },
  image: cn(
    "pointer-events-none block size-full object-cover duration-300",
    "group-hover/item:scale-103 group-hover/item:duration-800",
    "mask-b-from-50%",
  ),
  text: {
    base: cn(
      "relative text-center text-container-15 font-bold text-balance text-card-foreground",
    ),
    variant: {
      bottom: cn("absolute bottom-2", "md:bottom-4"),
      primary: cn(
        "bottom-10 text-container-28 text-primary uppercase",
        "md:bottom-20",
      ),
      stroke: cn("text-transparent"),
    },
  },
  badge: {
    base: cn(
      "absolute top-3 right-3 flex items-center justify-center gap-1 text-card-foreground opacity-80",
    ),
    animate: cn("animate-pulse"),
  },
};
